import * as angular from 'angular';
import { resolve } from '../../../../../init/store';
import { getUrlParam } from './getUrlParam';

export class Controller {

    /** @ngInject */
    constructor(Alert, ConfirmDeleteModal, SharedAccountsService) {
        this.Alert = Alert;
        this.ConfirmDeleteModal = ConfirmDeleteModal;
        this.SharedAccountsService = SharedAccountsService;
    }

    $onInit() {
        const url = this.resolve.account.publicServiceKey;

        this.$account = {
            ...this.resolve.account,
            digits: +getUrlParam(url, 'digits', 6),
            algorithm: getUrlParam(url, 'algorithm', 'SHA1'),
            secret: getUrlParam(url, 'secret'),
        };

        this.account = {...this.$account};
    }

    notModified() {
        return angular.equals(this.$account, this.account);
    }

    remove() {
        this.isRemoving = true;
        this.ConfirmDeleteModal('groups_users.confirm_company_user_account_delete')
            .then(() => this.SharedAccountsService.deleteCompanyServiceAccounts({
                companyId: resolve.companyId,
                id: this.account.id,
            }).$promise)
            .then(() => {
                this.close();
                this.Alert('success', 'company.sharing-center.manage.removed');
            })
            .finally(() => this.isRemoving = false)
    }

    save() {
        this.isSaving = true;
        this.SharedAccountsService.updateCompanyServiceAccounts(
            {
                companyId: resolve.companyId,
                publicServiceId: this.account.publicService.id,
            },
            {
                id: this.account.id,
                username: this.account.username,
                password: this.account.password,
                serviceLoginUrl: this.account.serviceLoginUrl,
                enabled2fa: true,
                showOtpEnabled: this.account.showOtpEnabled,
                showPasswordEnabled: this.account.showPasswordEnabled,
                publicServiceKey: generatePublicServiceKey(
                    this.account.publicService.serviceName,
                    this.account.username,
                    this.account.secret,
                    this.account.digits,
                    this.account.algorithm,
                ),
            }
        )
            .$promise
            .then(account => {
                this.close({$value: account});
                this.Alert('success', 'company.sharing-center.manage.saved');
            })
            .finally(() => this.isSaving = false)
    }

    saveDisabled(form) {
        return this.isSaving || form.$invalid || this.notModified();
    }
}

function generatePublicServiceKey(issuer, username, secretKey, digits, algorithm) {
    const secret = secretKey.replace(/\s/g, '');
    return `otpauth://totp/${issuer}:${username}?secret=${secret}&issuer=${issuer}&digits=${digits}&algorithm=${algorithm}`;
}



// WEBPACK FOOTER //
// ./src/portal/states/company/sharing-center/shared-authenticators/manage/manage-shared-authenticator.controller.js